import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_ACADEMIC_YEARS, 
    ADD_NEW_ACADEMIC_YEAR, 
    UPDATE_ACADEMIC_YEAR, 
    DELETE_ACADEMIC_YEAR,
    GET_ACTIVE_ACADEMIC_YEARS
} from "./actionTypes";

import {
    getAcademicYearsSuccess,
    getAcademicYearsFail,
    addAcademicYearSuccess,
    addAcademicYearFail,
    updateAcademicYearSuccess,
    updateAcademicYearFail,
    deleteAcademicYearSuccess,
    deleteAcademicYearFail,

    getActiveAcademicYearsSuccess, 
    getActiveAcademicYearsFail
   
} from "./actions"

import {
    getAcademicYears ,
    getActiveAcademicYears ,
    addNewAcademicYear,
    updateAcademicYear,
    deleteAcademicYear,
   
} from "helpers/academic-years/academic_years_backend_helper";
import { toast } from "react-toastify";

function* fetchAcademincYears() {
    try {
        const response = yield call(getAcademicYears)
        yield put(getAcademicYearsSuccess(response))
    } catch (error) {
        yield put(getAcademicYearsFail(error))
    }
}

function* onAddNewAcademicYear({ payload }) {
    try {

        
        const response = yield call(addNewAcademicYear, payload)

        yield put(addAcademicYearSuccess(response.academicYear))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addAcademicYearFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateAcademicYear({ payload}) {
    try {
        const response = yield call(updateAcademicYear, payload)
        yield put(updateAcademicYearSuccess(response.academicYear))
        //yield put(updateAcademicYearSuccess(response))

        // 🔹 FORCE LE RECHARGEMENT COMPLET
        // Comme ça, toutes les autres années repassent à "Non" (0)
        //yield put(getAcademicYears());


        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateAcademicYearFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteAcademicYear({ payload: data }) {

    try {
        const response = yield call(deleteAcademicYear, data)
        yield put(deleteAcademicYearSuccess(response.academicYearId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteAcademicYearFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* fetchActiveAcademicYears() {
    try {
        const response = yield call(getActiveAcademicYears);
        // On envoie les données au reducer
        yield put(getActiveAcademicYearsSuccess(response));
    } catch (error) {
        yield put(getActiveAcademicYearsFail(error));
    }
}


function* academicYearSaga() {
    yield takeEvery(GET_ACADEMIC_YEARS, fetchAcademincYears)
    yield takeEvery(GET_ACTIVE_ACADEMIC_YEARS, fetchActiveAcademicYears);
    yield takeEvery(ADD_NEW_ACADEMIC_YEAR, onAddNewAcademicYear)
    yield takeEvery(UPDATE_ACADEMIC_YEAR, onUpdateAcademicYear)
    yield takeEvery(DELETE_ACADEMIC_YEAR, onDeleteAcademicYear)
}

export default academicYearSaga;